import heic2any from "heic2any";
import { useState, useEffect } from "react";

const HeicViewer = ({ selectedDocument }) => {
    const [imageSrc, setImageSrc] = useState(null);

    useEffect(() => {
        const fetchAndConvertImage = async () => {
            try {
                const response = await fetch(selectedDocument);
                const blob = await response.blob();
                const convertedBlob = await heic2any({ blob, toType: "image/jpeg" });
                const imageUrl = URL.createObjectURL(convertedBlob);
                setImageSrc(imageUrl);
            } catch (error) {
                console.error("Error converting HEIC to JPEG:", error);
            }
        };

        fetchAndConvertImage();
    }, [selectedDocument]);

    return imageSrc ? (
        <img className="image1" src={imageSrc} alt="HEIC Preview" />
    ) : (
            <div className="flex justify-center items-center">
                <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
            </div>
    );
};

export default HeicViewer;
